"use strict";

define('app/models/notification.manager',['rs/models/notification.manager', 'rs/models/notification', 'rs/helper', 'moment'], function (NotificationManager, Notification, helper, moment) {
  var TaskManager = NotificationManager.extend({
    options: {
      name: 'notifications',
      displayName: 'Notifications',
      removeAll: true
    },
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.listenTo(this, 'read', this.notificationsWereRead);
    },
    notificationsWereRead: function notificationsWereRead() {
      var items = this.getUnread();
      if (!items.length) {
        return;
      }
      Notification.requestSetViewed(this.getUnread()).bind(this).then(this.refreshCount);
    },
    _canDeleteAll: function _canDeleteAll() {
      return true;
    },
    getUnread: function getUnread() {
      var items = _.pluck(this.getNotifications(), 'item');
      return _.reject(items, function (item) {
        return item.viewed;
      });
    },
    _getCount: function _getCount() {
      return this.getUnread().length;
    },
    _requestItems: function _requestItems() {
      return Notification.requestAll().then(function (items) {
        return _.sortBy(items, function (item) {
          return item.createDate;
        }).reverse();
      });
    },
    _getIdFromItem: function _getIdFromItem(item) {
      return item.getCreateDate();
    },
    _getTitleFromItem: function _getTitleFromItem(item) {
      return item.getNotificationTitle();
    },
    _getDateFromItem: function _getDateFromItem(item) {
      return item.getDateString();
    },
    _getBodyFromItem: function _getBodyFromItem(item) {},
    _getUnreadFromItem: function _getUnreadFromItem() {
      return false;
    },
    _getUrgencyFromItem: function _getUrgencyFromItem(item) {
      return item.isUrgent();
    },
    _canDelete: function _canDelete() {
      return true;
    },
    requestDeleteAll: function requestDeleteAll() {
      return Notification.requestDeleteAll();
    }
  });
  return TaskManager;
});

